import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Notificaciones, NotificacionesListUsers, TipoNotificacionFiltros } from '../models/notificaciones.model';
import { Observable } from 'rxjs';

const baseUrl = environment.serviceUrl_Notification;

@Injectable({
    providedIn: 'root'
})
export class NotificacionesService {
    constructor(
        private http: HttpClient
    ) { }

    getNotificacion(coduser: string) {
        return this.http.get(baseUrl + `buscar?userId=${coduser}`)
    }

    registerNotificacion(sender: Notificaciones): Observable<any> {
        return this.http.post(`${baseUrl}tipo`, sender)
    }

    updateNotificacion(sender: Notificaciones): Observable<any> {
        return this.http.put(`${baseUrl}tipo`, sender)
    }

    deleteNotificacion(tipnot: number): Observable<any> {
        return this.http.delete(`${baseUrl}tipo/${tipnot}`)
    }

    findList(): Observable<any> {
        return this.http.get<any[]>(`${baseUrl}tipo/buscar`)
    }

    findResources(): Observable<any> {
        return this.http.get<any[]>(`${baseUrl}tipo/recursos`)
    }

    findByTipNot(tipnot: number): Observable<any> {
        return this.http.get<any[]>(`${baseUrl}tipo/${tipnot}`)
    }


    registerListUsers(tipnot: number, sender: NotificacionesListUsers): Observable<any> {
        return this.http.post(`${baseUrl}tipo/${tipnot}/usuarios`, sender)
    }

    findResourcesFiltros(): Observable<any> {
        return this.http.get<any[]>(`${baseUrl}tipo/recursos/filtros`)
    }

    registerListFiltros(sender: TipoNotificacionFiltros): Observable<any> {
        return this.http.post(`${baseUrl}tipo/filtro`, sender)
    }

    deleteFiltro(tipnot: number, id: number): Observable<any> {
        return this.http.delete(`${baseUrl}tipo/${tipnot}/filtro/${id}`)
    }

    deleteUsuario(tipnot: number, coduser: string): Observable<any> {
        return this.http.delete(`${baseUrl}tipo/${tipnot}/usuarios/${coduser}`)
    }

    findTipos(): Observable<any> {
        return this.http.get<any[]>(`${baseUrl}tipos`)
    }
}